import styled from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'

const Heading = styled.div`
  margin-bottom: 15px;
  border-bottom: 2px solid ${props => props.theme.color.monochrome.light};
`

const Carousel = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
`

const QuickViewButton = styled(Button)`
  margin-right: 5px;

  @media screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    margin-right: 0;
  }
`

export { Heading, Carousel, QuickViewButton }
